import { render, staticRenderFns } from "./total-duration.vue?vue&type=template&id=223e0f5e&"
import script from "./total-duration.vue?vue&type=script&lang=js&"
export * from "./total-duration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports